import { Message,LoadingBar } from "view-design";
import iviewConfig from '@/config/iview-config';
import baseConfig from '@/config/base-config';
import HttpRequest from "./request";
import router from "../router";
import { loginOut } from "@/lib/util";

Message.config({
  top:iviewConfig.message_top || 100,
  duration: iviewConfig.message_duration || 3
});

export default {
  //成功提示语
  successTip:function(content,onClose){
    Message.success({content,onClose})
  },
  errorTip:function(content,onClose){
    Message.error({content,onClose})
  },
  postProxy:function (url,param) {
    let _self = this
    return new Promise(((resolve) => {
      LoadingBar.start()
      HttpRequest.post_proxy(url,param).then(response => {
        LoadingBar.finish()
        if (response.data.code === 501){
          loginOut()
          _self.errorTip('登陆过期，请重新登陆',()=>{
            _self.jumpTo('/login')
          })
        }else{
          resolve(response.data)
        }
      }).catch( () => {
        LoadingBar.finish()
        resolve(false)
      })
    }))
  },
  postProxyWithoutLoading:function(url,param){
    let _self = this
    return new Promise(((resolve) => {
      HttpRequest.post_proxy(url,param).then(response => {
        if (response.data.code === 501){
          loginOut()
          _self.errorTip('登陆过期，请重新登陆',()=>{
            _self.jumpTo('/login')
          })
        }else{
          resolve(response.data)
        }
      }).catch( () => {
        resolve(false)
      })
    }))
  },
  downFileByPost(url,param,fileName){
    let _self = this
    return new Promise(((resolve) => {
      LoadingBar.start()
      HttpRequest.down_file(url,param).then(response => {
        console.log(response)
        console.log(response.headers['errormsg'])
        LoadingBar.finish()
        if (response.headers['errormsg']){
          _self.errorTip(decodeURIComponent(response.headers['errormsg']))
        }else{
          if (!fileName) fileName = response.headers['filename'] ? decodeURIComponent(response.headers['filename']) : '表格.xlsx';
          let blob = new Blob([response.data], { type: 'application/octet-stream' });
          let reader = new FileReader();
          reader.readAsBinaryString(blob);
          let url = window.URL.createObjectURL(blob);
          const link = document.createElement('a'); // 创建a标签
          link.href = url;
          link.download = fileName; // 重命名文件
          link.click();
          URL.revokeObjectURL(url); // 释放内存
        }
        resolve(response)
      }).catch( (e) => {
        console.log(e)
        LoadingBar.finish()
        _self.errorTip('系统繁忙')
      })
    }))
  },
  /**
   * 接口返回数据统一处理，错误则直接弹出提示语
   * @param result
   * @param successCallback 数据成功的回调
   * @param errorCallBack 数据请求失败的回调
   * @returns {*}
   */
  dealApiResult(result,successCallback,errorCallBack){
    let _self = this
    if(result === false){
      return _self.errorTip('系统错误！')
    }else if(result.code === 200){
      return typeof successCallback === 'function' ? successCallback(result) : _self.successTip(result.msg || 'success')
    }else if(result.code !== 200){
      return typeof errorCallBack === 'function' ? errorCallBack(result) : _self.errorTip(result.msg || 'error')
    }else{
      return _self.errorTip(result.msg || 'error')
    }

  },
  /**
   * 页面跳转
   * @param path 跳转路径 跳转外部链接则必须是http开头
   * @param name 跳转name
   * @param params 参数
   * @returns
   */
  jumpTo(path,name,params){


    let option = {}
    if (path){
      if (path.indexOf('http') === 0){
        window.open(path)
        return
      }
      option = {path,query: params}
    }else if(name.indexOf('http') === 0){
      window.open(name)
      return
    }else{
      option = {name,params}
    }
    //必须catch 否则重复点击同一个路由会报错
    router.push(option).then(res => {

    }).catch(err => false)
  },

  //表格头部设置
  setTableColumns(columns){
    if (typeof columns !== 'object') return []
    let newColumn = [...columns]
    newColumn.forEach((val,key) => {
      val['align'] = val.align ? val.align : 'center'
      if (val.title === 'ID' && !val.width) val['width'] = 100
    })
    return newColumn
  },

  //导出数据
  exportExcel(searchData,api_url){
    let queryStr = '';
    for (let key in searchData){
      queryStr += `${key}=${searchData[key]}&`
    }
    window.open(baseConfig.API_PATH + api_url + '?' + queryStr)
  }




}
